// extracted by mini-css-extract-plugin
module.exports = {"modalBodyPadding":"confirmModal_modalBodyPadding__37ow5","modalBodyStyle":"confirmModal_modalBodyStyle__1HEkl"};